import { createForm10PDF, type Form10ClientParams } from '@gng-ehs/shared';
export type { Form10ClientParams } from '@gng-ehs/shared';

export function generateForm10ClientPDF(data: Form10ClientParams): string {
  return URL.createObjectURL(createForm10PDF(data).output('blob'));
}
